<template>
  <div>
    <img class="logo" :style="{'max-width':maxSize}" src="@/assets/logo.png" alt="Devbuds logo" />
  </div>
</template>

<script>
export default {
  name: "logo",
  props: {
    maxSize: {
      type: String,
      default: "150",
    },
  },
};
</script>

<style scoped>
.logo {
  width: 100%;
  height: auto;
}
</style>